// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style_tabs_2MFTs","contentPadding":"style_contentPadding_2sz13"};